import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import uniqid from "uniqid";
import { useConfirm } from "material-ui-confirm";
import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  Box,
  Button,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  LinearProgress,
  Link,
  MenuItem,
  Modal,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";

import {
  BCPSearch,
  BCPXmark,
  BCPAngleDown,
} from "../../components/icons/bcp/BCPIcons";

import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";

import DatePickerComponent from "../../components/utilities/DatePickerComponent";
import moment from "moment";

import GameSystemPicker from "../../components/utilities/gamesystempickers/GameSystemPicker";

import { Formik } from "formik";
import * as Yup from "yup";

import GenericPicker from "../../components/utilities/GenericPicker";
import ListResponsive from "../../components/other/ListResponsive";
import { globalVariables } from "../../global/GlobalVariables";
import {
  getGameSystems,
  handlePagingAll,
} from "../../components/api/APIUtilities";
import StyledMenu from "../../components/layout/StyledMenu";
import {
  delay,
  deleteData,
  getData,
  postData,
} from "../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import {
  getLocalStorage,
  hasCookiePermission,
  setLocalStorage,
} from "../../components/layout/cookies/CookieFunctions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

function a11yProps(index) {
  return {
    id: `admin-tab-${index}`,
    "aria-controls": `admin-tabpanel-${index}`,
  };
}

const buildGameSystemDict = (gameSystems) => {
  var dict = {};
  gameSystems.forEach((gameSystem) => {
    dict[gameSystem.id] = gameSystem;
  });
  return dict;
};

const searchLimit = 100;

export default function Utilities() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const confirm = useConfirm();

  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = async (e, newTab, freshEvent) => {
    setActiveTab(newTab);
  };

  const globalVars = globalVariables();
  const [loading, setLoading] = useState(true);

  const [searchReady, setSearchReady] = useState(false);
  const [showSearch, setShowSearch] = useState(true);
  const [searchValues, setSearchValues] = useState({
    startDate: "",
    endDate: moment().add(2, "months").endOf("month").format("YYYY-MM-DD"),
    gameType: "",
    eventSubType: "",
    location: "Global",
    searchString: "",
    started: true,
    ended: true,
    inclOnline: false,
  });

  var initalGameSystems = [];
  if (authContext?.authState?.cookieConsent) {
    var getGetCachedData = getLocalStorage(`gameSystems`);
    if (getGetCachedData) {
      initalGameSystems = JSON.parse(getGetCachedData);
    }
  }
  const [gameSystems, setGameSystems] = useState(initalGameSystems);
  const [gameSystemDict, setGameSystemDict] = useState(
    buildGameSystemDict(initalGameSystems)
  );

  const [eventListings, setEventListings] = useState(null);
  const [isSearching, setIsSearching] = useState(null);

  const getEvents = async (filters, nextKey) => {
    const queryStringParameters = {
      limit: searchLimit,
      ...filters,
    };
    if (nextKey) {
      queryStringParameters.nextKey = nextKey;
    }

    if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
      queryStringParameters.gameSystemId =
        getEnvironmentVariable("SINGLE_GAME_SYSTEM");
    } else if (getEnvironmentVariable("SINGLE_GAME_TYPE")) {
      queryStringParameters.gameType =
        getEnvironmentVariable("SINGLE_GAME_TYPE");
    } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
      queryStringParameters.gameSystemManufacturer = getEnvironmentVariable(
        "SINGLE_GAME_MANUFACTURER"
      );
    }

    var apiGetData = await getData("/events", {
      queryStringParameters: queryStringParameters,
    });

    if (
      apiGetData.data?.length === searchLimit &&
      apiGetData.nextKey &&
      apiGetData.nextKey !== nextKey
    ) {
      var nextFetch = await getEvents(filters, apiGetData.nextKey);
      if (nextFetch.data?.legth > 0)
        apiGetData.data = [...apiGetData.data, ...nextFetch?.data];
    }

    return apiGetData.data;
  };

  const [leagues, setLeagues] = useState(null);

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);

  useEffect(() => {
    const go = async () => {
      if (activeTab === 0) {
        setShowSearch(true);
      } else if (activeTab === 1) {
        setLeagues(null);
        setIsSearching(true);
        try {
          let apiLeagues = await handlePagingAll(`/leagues`, {
            limit: 100,
            "expand[]": ["gameStore", "gameSystem"],
          });

          setLeagues(apiLeagues);
        } catch (err) {
          //
        }
        setIsSearching(null);
      }
    };
    go();
  }, [activeTab]);

  useEffect(() => {
    const check = async () => {
      if (authContext?.authState?.identity?.isAdmin !== true) {
        navigate("/home");
        setLoading(false);

        return;
      }

      setSearchValues({
        ...searchValues,
        location: "Global",
      });

      setSearchReady(true);

      var data = await getGameSystems();
      setGameSystems(data);
      setGameSystemDict(buildGameSystemDict(data));
      if (authContext?.authState?.cookieConsent) {
        try {
          var getCachedItems = getLocalStorage("CachedItems");
          var cachedItems = getCachedItems ? JSON.parse(getCachedItems) : {};
          if (hasCookiePermission("gameSystems", authContext)) {
            setLocalStorage("gameSystems", JSON.stringify(data));
            cachedItems["gameSystems"] = true;
          }
          setLocalStorage("CachedItems", JSON.stringify(cachedItems));
        } catch (err) {}
      }

      setLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {Boolean(loading) && <ModalLoadingFull />}
      <Container
        sx={{
          m: 1,
          pt: 2,
          pb: 2,
          width: "calc(100% - 16px)",
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1,
          backgroundColor: "background.secondary",
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            mb: 2,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="admin tabs"
          >
            <Tab label="Events" {...a11yProps(0)} />
            <Tab label="Circuits" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={activeTab} index={0}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                boxShadow: 1,
                backgroundColor: "background.secondary",
              }}
            >
              <Typography variant="h3">Event Listings</Typography>
            </Grid>
            {showSearch && (
              <Grid
                item
                xs={12}
                sx={{
                  p: 2,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: 1,
                  boxShadow: 1,
                  backgroundColor: "background.secondary",
                }}
              >
                <Formik
                  initialValues={searchValues}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    searchString: Yup.string()
                      .min(3, "Minimum 3 Characters!")
                      .max(255, "Maximum 255 Characters!"),
                  })}
                  onSubmit={async (
                    values,
                    { setSubmitting, setFieldValue }
                  ) => {
                    try {
                      setIsSearching(true);
                      setEventListings([]);
                      var filters = {
                        inclEventClass: true,
                      };

                      if (values.startDate && values.startDate !== "") {
                        filters.startDate = moment(
                          values.startDate,
                          "YYYY-MM-DD HH:mm"
                        )
                          .utc()
                          .format();
                      }
                      if (values.endDate && values.endDate !== "") {
                        filters.endDate = moment(
                          values.endDate,
                          "YYYY-MM-DD HH:mm"
                        )
                          .utc()
                          .format();
                      }

                      if (
                        filters.startDate &&
                        filters.endDate &&
                        moment(filters.startDate).isAfter(
                          moment(filters.endDate)
                        )
                      ) {
                        throw new Error(
                          "Start Date must be before the End Date"
                        );
                      }

                      if (typeof values.gameType === "number") {
                        filters.gameType = values.gameType;
                      }
                      if (values.eventSubType && values.eventSubType !== "") {
                        filters.eventSubType = values.eventSubType;
                      }

                      if (values.searchString?.length > 0) {
                        filters.searchString =
                          values.searchString.toLowerCase();
                      }

                      if (values.started) {
                        filters.started = values.started;
                      }
                      if (values.ended) {
                        filters.ended = values.ended;
                      }

                      var events = await getEvents(filters, null);

                      events = events.filter((event) => {
                        if (!values.inclOnline && event.isOnlineEvent) {
                          return false;
                        }
                        return true;
                      });

                      if (events.length === 0) {
                        postNotification(
                          "info",
                          "No events found matching your search criteria."
                        );
                      } else {
                        events.forEach((event) => {
                          if (
                            event.gameSystemId &&
                            gameSystemDict[event.gameSystemId]
                          )
                            event.gameSystem =
                              gameSystemDict[event.gameSystemId];

                          event.eventLocation = "";
                          if (
                            event.gameStoreName &&
                            event.gameStoreName !== ""
                          ) {
                            event.eventLocation = event.gameStoreName;
                          }
                          if (event.city && event.city !== "") {
                            if (event.eventLocation !== "") {
                              event.eventLocation += ", ";
                            }
                            event.eventLocation += event.city;
                          }
                          if (event.state && event.state !== "") {
                            if (event.eventLocation !== "") {
                              event.eventLocation += ", ";
                            }
                            event.eventLocation += event.state;
                          }
                          if (event.country && event.country !== "") {
                            if (event.eventLocation !== "") {
                              event.eventLocation += ", ";
                            }
                            event.eventLocation += event.country;
                          }

                          if (event.pricingDict) {
                            var keys = Object.keys(event.pricingDict);
                            if (keys.length > 0) {
                              event.pricingInfo = {
                                currency: keys[0],
                                amount: (
                                  event.pricingDict[keys[0]] / 100
                                ).toFixed(2),
                              };
                            }
                          }
                        });
                      }
                      setEventListings(events);
                      setIsSearching(false);
                      setShowSearch(false);
                    } catch (error) {
                      postNotification("error", error);
                      setIsSearching(false);
                    }
                  }}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    touched,
                    values,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <DatePickerComponent
                            name="startDate"
                            label="Start Date"
                            value={values.startDate}
                            setFieldValue={setFieldValue}
                            error={Boolean(
                              touched.startDate && values.startDate === ""
                            )}
                            helperText={
                              touched.startDate && values.startDate === ""
                                ? "Required"
                                : null
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <DatePickerComponent
                            name="endDate"
                            label="End Date"
                            value={values.endDate}
                            setFieldValue={setFieldValue}
                            error={Boolean(
                              touched.endDate && values.endDate === ""
                            )}
                            helperText={
                              touched.endDate && values.endDate === ""
                                ? "Required"
                                : null
                            }
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={
                            globalVars?.eventSubTypes?.list?.length > 0 ? 6 : 12
                          }
                        >
                          <GameSystemPicker
                            name="gameType"
                            value={values.gameType}
                            handleChange={handleChange}
                            gameSystems={gameSystems}
                            touched={touched.gameType}
                            error={errors.gameType}
                            allowAny
                          />
                        </Grid>
                        {globalVars?.eventSubTypes?.list?.length > 0 && (
                          <Grid item xs={12} sm={6}>
                            <GenericPicker
                              name="eventSubType"
                              label={
                                globalVars?.eventSubTypes?.label ||
                                "Event Sub Type"
                              }
                              value={values.eventSubType}
                              handleChange={handleChange}
                              list={globalVars.eventSubTypes.list || []}
                              inclAny={true}
                            />
                          </Grid>
                        )}
                        <Grid item xs={12}>
                          <TextField
                            name="searchString"
                            label="Event Name (Optional)"
                            value={values.searchString}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={Boolean(
                              touched.searchString && errors.searchString
                            )}
                            helperText={
                              touched.searchString && errors.searchString
                            }
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <FormControlLabel
                            label="Started"
                            sx={{
                              ml: 0,
                              width: "100%",
                              "& .MuiFormControlLabel-label": {
                                width: "calc(100% - 58px)",
                              },
                            }}
                            control={
                              <Switch
                                checked={values.started}
                                onChange={(e) => {
                                  setFieldValue("started", !values.started);
                                }}
                              />
                            }
                            labelPlacement="start"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            label="Ended"
                            sx={{
                              ml: 0,
                              width: "100%",
                              "& .MuiFormControlLabel-label": {
                                width: "calc(100% - 58px)",
                              },
                            }}
                            control={
                              <Switch
                                checked={values.ended}
                                onChange={(e) => {
                                  setFieldValue("ended", !values.ended);
                                }}
                              />
                            }
                            labelPlacement="start"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            label="Include Online"
                            sx={{
                              ml: 0,
                              width: "100%",
                              "& .MuiFormControlLabel-label": {
                                width: "calc(100% - 58px)",
                              },
                            }}
                            control={
                              <Switch
                                checked={values.inclOnline}
                                onChange={(e) => {
                                  setFieldValue(
                                    "inclOnline",
                                    !values.inclOnline
                                  );
                                }}
                              />
                            }
                            labelPlacement="start"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Button
                            type="submit"
                            color={"primary"}
                            variant={"contained"}
                            fullWidth
                            startIcon={<BCPSearch />}
                          >
                            Search
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
              </Grid>
            )}
            {isSearching !== null && !showSearch && (
              <Grid
                item
                xs={12}
                sx={{
                  p: 2,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: 1,
                  boxShadow: 1,
                  backgroundColor: "background.secondary",
                }}
              >
                <ListResponsive
                  originalList={isSearching ? null : eventListings}
                  doSearch
                  actionButton={[
                    {
                      props: {
                        variant: "contained",
                        color: "primary",
                        onClick: () => setShowSearch(true),
                        startIcon: <BCPSearch />,
                      },
                      label: "New Search",
                    },
                    {
                      props: {
                        variant: "outlined",
                        color: "primary",
                        "aria-expanded": Boolean(optionsAnchorEl)
                          ? true
                          : undefined,
                        onClick: (e) => {
                          setOptionsAnchorEl(e.currentTarget);
                        },
                        endIcon: <BCPAngleDown />,
                      },
                      label: "Options",
                    },
                  ]}
                  doPages
                  initialRowsPerPage={24}
                  rowsPerPageArray={[
                    12,
                    24,
                    48,
                    96,
                    { label: "All", value: -1 },
                  ]}
                  searchProps={{
                    label: "Search Results",
                    performSearch: (originalList, searchText) => {
                      if (!searchText || searchText === "") {
                        return originalList;
                      } else {
                        var filteredList = originalList.filter(function (el) {
                          if (el?.name?.toLowerCase().includes(searchText))
                            return true;
                          if (
                            el?.eventLocation
                              ?.toLowerCase()
                              .includes(searchText)
                          )
                            return true;
                          if (
                            el?.gameSystem?.name
                              ?.toLowerCase()
                              .includes(searchText)
                          )
                            return true;
                          if (
                            el?.gameStoreName
                              ?.toLowerCase()
                              .includes(searchText)
                          )
                            return true;
                          if (
                            el?.ownerFirstName
                              ?.toLowerCase()
                              .includes(searchText)
                          )
                            return true;
                          if (
                            el?.ownerLastName
                              ?.toLowerCase()
                              .includes(searchText)
                          )
                            return true;
                          return false;
                        });
                        return filteredList;
                      }
                    },
                  }}
                  rowProps={{
                    mapFunction: (row, index) => (
                      <Grid
                        key={index}
                        item
                        xs={12}
                        sx={{
                          p: 1,
                          mb: 1,
                          border: "1px solid rgba(0, 0, 0, 0.12)",
                          borderRadius: 1,
                          boxShadow: 1,
                          "&:hover": {
                            cursor: "pointer",
                          },
                        }}
                      >
                        <Link
                          href={`/event/${row.id}`}
                          target="_blank"
                          underline="none"
                          color="inherit"
                        >
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Typography variant="body1">
                                {row.name} -{" "}
                                {moment(row.eventEndDate).format(
                                  "YYYY-MM-DD HH:mm"
                                )}
                              </Typography>
                              <Typography variant="caption">
                                {`${row.gameSystem?.name} :${
                                  row.eventSubType && row.eventSubType !== ""
                                    ? ` ${row.eventSubType} :`
                                    : ""
                                } ${
                                  row.started
                                    ? //  && row.currentRound > 0
                                      "Started"
                                    : "Not Started"
                                } : ${row.ended ? "Ended" : "Not Ended"}`}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Link>
                      </Grid>
                    ),
                  }}
                />
                <OptionsMenu
                  anchorEl={optionsAnchorEl}
                  setAnchorEl={setOptionsAnchorEl}
                  setLoading={setLoading}
                  eventListings={eventListings}
                  authContext={authContext}
                />
              </Grid>
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <ListResponsive
            originalList={isSearching ? null : leagues}
            doSearch
            doPages
            initialRowsPerPage={24}
            rowsPerPageArray={[10, 20, 50, 100, { label: "All", value: -1 }]}
            searchProps={{
              label: "Search Results",
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  var filteredList = originalList.filter(function (el) {
                    if (el?.name?.toLowerCase().includes(searchText))
                      return true;
                    if (
                      el?.gameSystem?.name?.toLowerCase().includes(searchText)
                    )
                      return true;
                    if (el?.gameStore?.name?.toLowerCase().includes(searchText))
                      return true;
                    return false;
                  });
                  return filteredList;
                }
              },
            }}
            rowProps={{
              mapFunction: (row, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  sx={{
                    p: 1,
                    mb: 1,
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: 1,
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="body1">{row.name}</Typography>
                      <Typography variant="caption">
                        {row.gameSystem?.name}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={async () => {
                          try {
                            await confirm({
                              title: `Are you sure?`,
                              description:
                                "Are you really sure you wish to reset the ELO for this circut",
                              dialogProps: {
                                sx: {
                                  zIndex: 99999,
                                },
                              },
                            });
                          } catch (err) {
                            return;
                          }

                          try {
                            await confirm({
                              title: `Are you really sure?`,
                              description:
                                "Are you really sure you wish to reset the ELO for this circut",
                              dialogProps: {
                                sx: {
                                  zIndex: 99999,
                                },
                              },
                            });
                          } catch (err) {
                            return;
                          }

                          setLoading(true);
                          await deleteData(`/leagues/${row.id}/deleteELO`);
                          setLoading(false);
                        }}
                      >
                        Clear ELO
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              ),
            }}
          />
        </TabPanel>
        {(isSearching || !searchReady) && <ModalLoadingFull />}
      </Container>
    </>
  );
}

function OptionsMenu(props) {
  const { anchorEl, setAnchorEl, setLoading, eventListings } = props;
  const open = Boolean(anchorEl);
  const [circuitOpen, setCircuitOpen] = useState(false);
  return (
    <>
      <StyledMenu
        id="options-menu"
        MenuListProps={{
          "aria-labelledby": "options-button",
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={async (e) => {
            setCircuitOpen(true);
            setAnchorEl(null);
          }}
          disableRipple
        >
          Submit to circuit
        </MenuItem>
      </StyledMenu>
      <SubmitToCircuitModal
        open={circuitOpen}
        setOpen={setCircuitOpen}
        setLoading={setLoading}
        eventListings={eventListings}
      />
    </>
  );
}

function SubmitToCircuitModal(props) {
  const { open, setOpen, setLoading, eventListings } = props;
  const [leagues, setLeagues] = useState([]);

  const [tokenGeneration, setTokenGeneration] = useState("");

  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const go = async () => {
      setLeagues([]);
      setTokenGeneration("");
      setProgress(0);
      setMessage("");
      if (open) {
        var gameSystemId;
        try {
          eventListings.forEach((event) => {
            if (!gameSystemId) {
              gameSystemId = event.gameSystem?.id;
            } else if (gameSystemId !== event.gameSystem?.id) {
              throw new Error(
                "Please limit your event search to one Game System"
              );
            }

            if (!event.ended) {
              throw new Error(
                "Please limit your event search to ended events only"
              );
            }
          });
        } catch (err) {
          postNotification("error", err.message || JSON.stringify(err));
          setOpen(false);
          return;
        }

        setLoading(true);

        var apiLeagues = await handlePagingAll("/leagues", {
          gameSystemId: gameSystemId,
          "expand[]": ["gameSystem"],
        });
        setLeagues(apiLeagues);

        setLoading(false);
      }
    };
    go();
    // eslint-disable-next-line
  }, [open]);

  return (
    <>
      <Modal
        disableAutoFocus
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{ zIndex: 9999 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs>
              <Typography variant="h4" component="h2">
                Submit Events to Circuits
              </Typography>
            </Grid>
          </Grid>
          {leagues?.length > 0 && (
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <GenericPicker
                  label="Circuit Tokens"
                  required
                  inclAny={false}
                  name="tokenGeneration"
                  list={[
                    {
                      value: "yes",
                      label: "Generate New Tokens",
                    },
                    {
                      value: "no",
                      label: "Don't Generate Tokens",
                    },
                  ]}
                  value={tokenGeneration}
                  handleChange={(e) => {
                    setTokenGeneration(e.target.value);
                  }}
                />
              </Grid>
              {leagues.map((league, index) => {
                return (
                  <Grid key={index} item xs={12}>
                    <Button
                      variant="outlined"
                      color="primary"
                      fullWidth
                      disabled={tokenGeneration === ""}
                      onClick={async () => {
                        var eventListingTemp = [...eventListings];
                        eventListingTemp.sort((a, b) => {
                          let aST = a.startedTime || a.eventDate;
                          let bST = b.startedTime || b.eventDate;
                          return moment(aST).diff(moment(bST));
                        });

                        setProgress(0.01);

                        try {
                          for (let i = 0; i < eventListingTemp?.length; i++) {
                            var body = {
                              leagueId: league?.id,
                            };
                            if (tokenGeneration === "yes") {
                              body.tokenCode = uniqid();
                            }
                            await postData(
                              `/events/${eventListingTemp[i].id}/forceSubmitListing`,
                              {
                                body: body,
                              }
                            );
                            setProgress(
                              ((i + 1) / eventListingTemp.length) * 100
                            );
                            setMessage(
                              `${
                                (eventListingTemp.length - (i + 1)) * 6
                              } seconds remaining`
                            );
                            if (i + 1 !== eventListingTemp?.length) {
                              await delay(5000);
                            }
                          }
                        } catch (err) {
                          postNotification("error", err);
                          setProgress(0);
                          return;
                        }
                        postNotification("success", "Events submitted");
                        setProgress(0);
                      }}
                    >
                      {league.name}
                    </Button>
                  </Grid>
                );
              })}
            </Grid>
          )}
        </Box>
      </Modal>
      <ProgressModal open={progress > 0} value={progress} message={message} />
    </>
  );
}

function ProgressModal(props) {
  const { open, value, message } = props;

  return (
    <Modal
      disableAutoFocus
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          maxHeight: "95vh",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ width: "100%", mr: 1 }}>
            <LinearProgress variant="determinate" value={value} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">{`${Math.round(
              value
            )}%`}</Typography>
            {message && (
              <Typography variant="body2" color="text.secondary">
                {message}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export async function hasAdminAccess(authContext, tabIndex, notify) {
  var err;

  if (authContext?.authState?.identity?.isAdmin === true) {
    return true;
  }

  err = new Error("You do not have access to this function");
  if (notify) postNotification("warning", err);

  if (err) {
    throw err;
  }
  return false;
}
